import VueRouter from 'vue-router';

// PAT-managed HTML (info bars, landing bars) is rendered with v-html, so its links are
// plain anchors. A relative one like <a href="/contact"> reloads the whole page without
// ?lang — and the `language` cookie that should restore it is blocked by the cookie
// consent tool, so every language version landed on the German page. Internal links are
// routed instead: the patched router.push appends the current lang and skips the reload.
export const routeInternalContentLink = (event: MouseEvent, router: VueRouter) => {
  const link = (event.target as HTMLElement).closest('a');
  if (!link) return;

  const href = link.getAttribute('href');
  // only same-site paths — external URLs, protocol-relative //host, mailto: etc. stay native
  if (!href || !href.startsWith('/') || href.startsWith('//')) return;

  // keep the browser's "open in new tab" behaviour
  const opensElsewhere = link.target === '_blank' || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0;
  if (opensElsewhere) return;

  event.preventDefault();
  router.push(href).catch(() => {
    // NavigationDuplicated when the link points at the current page — nothing to do
  });
};
